import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Phone, Mail, MapPin, Menu, X, Facebook, Instagram, ChevronRight } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-border/50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80" data-id="element-74">
      {/* Top Bar */}
      <div className="hidden md:flex items-center justify-between px-6 py-2 bg-card text-xs text-muted-foreground border-b border-border" data-id="element-75">
        <div className="flex items-center gap-6" data-id="element-76">
          <div className="flex items-center gap-2" data-id="element-77">
            <Phone className="h-3 w-3 text-primary" data-id="element-78" />
            <span data-id="element-79">706-714-0156</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-80">
            <Mail className="h-3 w-3 text-primary" data-id="element-81" />
            <span data-id="element-82">info@dropzonecleanup.com</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-83">
            <MapPin className="h-3 w-3 text-primary" data-id="element-84" />
            <span data-id="element-85">Winder, GA 30680</span>
          </div>
        </div>
        <div className="flex items-center gap-4" data-id="element-86">
          <a href="https://www.facebook.com/DropZoneCleanUp" target="_blank" rel="noreferrer" className="hover:text-primary transition-colors" data-id="element-87">
            <Facebook className="h-4 w-4" data-id="element-88" />
          </a>
          <a href="https://www.instagram.com/dropzonecleanup" target="_blank" rel="noreferrer" className="hover:text-primary transition-colors" data-id="element-89">
            <Instagram className="h-4 w-4" data-id="element-90" />
          </a>
        </div>
      </div>

      {/* Main Nav */}
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-91">
        <div className="flex items-center gap-3" data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/qgLYFiqJ263fT3C8koLsbm/logo.webp" alt="Drop Zone Cleanup Co." className="h-12 w-auto" data-id="element-93" />
          <div className="flex flex-col" data-id="element-94">
            <span className="font-heading font-black text-xl tracking-tight leading-none uppercase" data-id="element-95">
              Drop Zone
            </span>
            <span className="text-primary font-bold text-sm tracking-widest uppercase" data-id="element-96">
              Cleanup Co.
            </span>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-8" data-id="element-97">
          <a href="#services" className="text-sm font-medium hover:text-primary transition-colors uppercase tracking-wider" data-id="element-98">
            Services
          </a>
          <a href="#about" className="text-sm font-medium hover:text-primary transition-colors uppercase tracking-wider" data-id="element-99">
            About
          </a>
          <a href="#process" className="text-sm font-medium hover:text-primary transition-colors uppercase tracking-wider" data-id="element-100">
            Process
          </a>
          <a href="#faq" className="text-sm font-medium hover:text-primary transition-colors uppercase tracking-wider" data-id="element-101">
            FAQ
          </a>
        </nav>

        <div className="hidden md:flex items-center gap-4" data-id="element-102">
          <Button variant="outline" className="uppercase font-bold tracking-wider" data-id="element-103">
            Client Login
          </Button>
          <Button className="uppercase font-bold tracking-wider group" data-id="element-104">
            Get a Quote
            <ChevronRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-105" />
          </Button>
        </div>

        <button className="md:hidden p-2 text-foreground" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-106">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-107" /> : <Menu className="h-6 w-6" data-id="element-108" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-card border-b border-border p-4 flex flex-col gap-4 shadow-xl" data-id="element-109">
          <a href="#services" className="text-sm font-medium p-2 hover:bg-secondary rounded uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-110">
            Services
          </a>
          <a href="#about" className="text-sm font-medium p-2 hover:bg-secondary rounded uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-111">
            About
          </a>
          <a href="#process" className="text-sm font-medium p-2 hover:bg-secondary rounded uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-112">
            Process
          </a>
          <a href="#faq" className="text-sm font-medium p-2 hover:bg-secondary rounded uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-113">
            FAQ
          </a>
          <div className="flex flex-col gap-2 pt-4 border-t border-border" data-id="element-114">
            <Button variant="outline" className="w-full uppercase font-bold tracking-wider" data-id="element-115">
              Client Login
            </Button>
            <Button className="w-full uppercase font-bold tracking-wider" data-id="element-116">
              Get a Quote
            </Button>
          </div>
        </div>}
    </header>;
}